/**
 * Mobile Device Detection Utility
 * Detects if the user is on a mobile device (iOS or Android)
 */

/**
 * Check if the user is on a mobile device (iOS or Android phones, not tablets)
 * This is more specific than just screen size - it checks the user agent
 */
export function isMobileDevice(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();
  
  // Check for iPhone (mobile, not iPad)
  const isIPhone = /iphone/.test(userAgent);
  
  // Check for Android phones (exclude tablets)
  // Android tablets typically don't have "mobile" in the user agent
  const isAndroidPhone = /android/.test(userAgent) && /mobile/.test(userAgent);
  
  // Check for other mobile user agent patterns (excluding tablets)
  const isMobileUA = /mobile/.test(userAgent) && 
                     !/tablet|ipad/.test(userAgent) &&
                     !/android/.test(userAgent); // Android handled separately above
  
  return isIPhone || isAndroidPhone || isMobileUA;
}

/**
 * Detect the mobile platform (iOS or Android)
 * Returns 'ios' for iPhone, 'android' for Android phones, null otherwise
 */
export function getMobilePlatform(): 'ios' | 'android' | null {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return null;
  }

  const userAgent = navigator.userAgent.toLowerCase();
  
  // Check for iPhone (not iPad)
  if (/iphone/.test(userAgent)) {
    return 'ios';
  }
  
  // Check for Android phones (exclude tablets)
  if (/android/.test(userAgent) && /mobile/.test(userAgent)) {
    return 'android';
  }
  
  return null;
}
